import { render, staticRenderFns } from "./SurveyReportSettings.vue?vue&type=template&id=7054900d"
import script from "./SurveyReportSettings.vue?vue&type=script&lang=js"
export * from "./SurveyReportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports